<template>
    <div v-if="value.count">
        <router-link :to="link" class="btn btn-default btn-xs" target="_blank">
            <span class='fa fa-magic'></span>
            <span>View {{ value.count }}</span>
        </router-link>
    </div>
</template>

<script>
export default {
    props: ['value'],
    computed: {
        link() {
            return {
                path: '/wishlists',
                query: { s: this.value.asin },
            };
        },
    },
};
</script>
